<div class="content-wrapper container-xxl p-2">
  <div class="content-body">

    <div class="row">
      <div class="col-lg-3 col-sm-6 mb-4" *ngFor="let item of wallet">
        <div class="card h-100">
          <div class="rounded-3 p-2 d-flex flex-column align-items-start">
            <small class="text-muted">Balance Summary</small>
            <div class="d-flex justify-content-between w-100 mt-1">
              <div>
                <div class="fw-semibold text-success">{{ item.totalIncome/100 | currency:item.currency }}</div>
                <small class="text-muted">Income</small>
              </div>
              <div class="text-end">
                <div class="fw-semibold text-danger">{{ item.totalDept/100 | currency:item.currency }}</div>
                <small class="text-muted">Debt</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Users Distribution -->
        <div class="row ">
          <!-- Total No. of Users By Role -->
          <div class="col-md-6 mb-2">
            <div class="card h-100">
              <div class="card-header">
                <h5>Total No. of Users By Role</h5>
              </div>
              <div class="card-body">
                <apx-chart *ngIf="roleChartOptions"
                           [series]="roleChartOptions.series"
                           [chart]="roleChartOptions.chart"
                           [labels]="roleChartOptions.labels"
                           [colors]="roleChartOptions.colors"
                           [legend]="roleChartOptions.legend">
                </apx-chart>
              </div>
            </div>
          </div>
    
          <!-- Total No. of Users By Countries -->
          <div class="col-md-6 mb-2">
            <div class="card h-100">
              <div class="card-header">
                <h5>Total No. of Users By Countries</h5>
              </div>
              <div class="card-body">
                <apx-chart *ngIf="countryChartOptions"
                           [series]="countryChartOptions.series"
                           [chart]="countryChartOptions.chart"
                           [labels]="countryChartOptions.labels"
                           [colors]="countryChartOptions.colors"
                           [legend]="countryChartOptions.legend">
                </apx-chart>
              </div>
            </div>
          </div>
        </div>


    

    <!-- Sub Roles & Verification Charts -->
    <div class="row mt-2">
      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Sub Roles</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="subRolesOption"
              [series]="subRolesOption.series" [chart]="subRolesOption.chart"
              [labels]="subRolesOption.labels" [colors]="subRolesOption.colors" [legend]="subRolesOption.legend">
            </apx-chart>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>User Classified by Verification Status</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="verificationOption"
              [series]="verificationOption.series" [chart]="verificationOption.chart"
              [labels]="verificationOption.labels" [colors]="verificationOption.colors" [legend]="verificationOption.legend">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Friends & Posts Charts -->
    <div class="row mt-2">
      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Friends Count</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="friendsChart"
              [series]="friendsChart.series" [chart]="friendsChart.chart"
              [labels]="friendsChart.labels" [colors]="friendsChart.colors" [legend]="friendsChart.legend">
            </apx-chart>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Posts Count</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="postChart"
              [series]="postChart.series" [chart]="postChart.chart"
              [labels]="postChart.labels" [colors]="postChart.colors" [legend]="postChart.legend">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Registration Statistics -->
    <div class="row mt-2">
      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Total Registration Past 24h by Country</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="registrationPerDay"
              [series]="registrationPerDay.series" [chart]="registrationPerDay.chart"
              [labels]="registrationPerDay.labels" [colors]="registrationPerDay.colors" [legend]="registrationPerDay.legend">
            </apx-chart>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Total Registration per Month</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="registerPerMonth"
              [series]="registerPerMonth.series" [chart]="registerPerMonth.chart"
              [labels]="registerPerMonth.labels" [colors]="registerPerMonth.colors" [legend]="registerPerMonth.legend">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Most Viewed Profile -->
    <div class="card mt-2">
      <div class="card-header">
        <h5 class="font-weight-bold">Most Viewed Profiles</h5>
      </div>
      <div class="card-body">
        <ngx-datatable
          class="bootstrap core-bootstrap bg-white border"
          [rows]="rows"
          [columns]="columns"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="10">
        </ngx-datatable>
      </div>
    </div>

    <!-- Profile Segmentation -->
    <div class="card mt-2">
      <div class="card-header">
        <h5>Profile Views Segmentation</h5>
      </div>
      <div class="card-body">
        <apx-chart *ngIf="profileSegement"
          [series]="profileSegement.series" [chart]="profileSegement.chart"
          [labels]="profileSegement.labels" [colors]="profileSegement.colors" [legend]="profileSegement.legend">
        </apx-chart>
      </div>
    </div>

    <!-- Weekly Registrations & Posts -->
    <div class="row mt-2">
      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Registration Last 7 Days by Role</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="registrationLastWeek"
              [series]="registrationLastWeek.series" [chart]="registrationLastWeek.chart"
              [labels]="registrationLastWeek.labels" [colors]="registrationLastWeek.colors" [legend]="registrationLastWeek.legend">
            </apx-chart>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-2">
        <div class="card h-100">
          <div class="card-header">
            <h5>Total Number of Posts Last 7 Days</h5>
          </div>
          <div class="card-body">
            <apx-chart *ngIf="weeklypost"
              [series]="weeklypost.series" [chart]="weeklypost.chart"
              [labels]="weeklypost.labels" [colors]="weeklypost.colors" [legend]="weeklypost.legend"
              [xaxis]="weeklypost.xaxis">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Logged in Users last month -->
<!-- Games By Country Chart -->
<div class="row mt-2">
  <!-- Games By Country -->
  <div class="col-md-6 mb-2">
    <div class="card h-100">
      <div class="card-header">
        <h5>Games By Country</h5>
      </div>
      <div class="card-body">
        <apx-chart *ngIf="gamesByCountryOption"
                   [series]="gamesByCountryOption.series"
                   [chart]="gamesByCountryOption.chart"
                   [labels]="gamesByCountryOption.labels"
                   [colors]="gamesByCountryOption.colors"
                   [legend]="gamesByCountryOption.legend">
        </apx-chart>
      </div>
    </div>
  </div>

  <!-- Games Posts by Buckets -->
  <div class="col-md-6 mb-2">
    <div class="card h-100">
      <div class="card-header">
        <h5>Games Posts by Buckets</h5>
      </div>
      <div class="card-body">
        <apx-chart *ngIf="gamesByBucketsOption"
                   [series]="gamesByBucketsOption.series"
                   [chart]="gamesByBucketsOption.chart"
                   [labels]="gamesByBucketsOption.labels"
                   [colors]="gamesByBucketsOption.colors"
                   [legend]="gamesByBucketsOption.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<!-- Challenges by Buckets (commented out) -->
<!--
<div class="card col-md-5 col-sm-12 mb-4">
  <div class="card-header">
    <h5>Challenges by Buckets</h5>
  </div>
  <div class="card-body">
    <apx-chart *ngIf="challengesByBucketsOption"
               [series]="challengesByBucketsOption.series"
               [chart]="challengesByBucketsOption.chart"
               [labels]="challengesByBucketsOption.labels"
               [colors]="challengesByBucketsOption.colors"
               [legend]="challengesByBucketsOption.legend">
    </apx-chart>
  </div>
</div>
-->
<!-- Total number of logged in users by role last month   -->
<div class="row mt-2">
  <!-- Total number of logged in users last month by role -->
  <div class="col-md-6 mb-2">
    <div class="card h-100">
      <div class="card-header">
        <h5>Total Number of Logged-in Users Last Month by Role</h5>
      </div>
      <div class="card-body">
        <apx-chart *ngIf="repeatedLoggedInLastMonth"
          [series]="repeatedLoggedInLastMonth.series" [chart]="repeatedLoggedInLastMonth.chart"
          [labels]="repeatedLoggedInLastMonth.labels" [colors]="repeatedLoggedInLastMonth.colors"
          [legend]="repeatedLoggedInLastMonth.legend">
        </apx-chart>
      </div>
    </div>
  </div>

  <!-- Total number of logged in users last week by role -->
  <div class="col-md-6 mb-2">
    <div class="card h-100">
      <div class="card-header">
        <h5>Total Number of Logged-in Users Last Week by Role</h5>
      </div>
      <div class="card-body">
        <apx-chart *ngIf="repeatedLoggedInLastWeek"
          [series]="repeatedLoggedInLastWeek.series" [chart]="repeatedLoggedInLastWeek.chart"
          [labels]="repeatedLoggedInLastWeek.labels" [colors]="repeatedLoggedInLastWeek.colors"
          [legend]="repeatedLoggedInLastWeek.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<!-- "Clubs Added by 3 users at least "-->
<div class="card col-md-12 col-sm-12">
  <div class="card-header">
    <h5>club added by at least 3 users
    </h5>
  </div>
  <div class=" card-body ">
    <apx-chart *ngIf="commonClubs" [series]="commonClubs.series" [chart]="commonClubs.chart"
      [labels]="commonClubs.labels" [colors]="commonClubs.colors" [legend]="commonClubs.legend"
      >
    </apx-chart>
  </div>

</div>
<!-- "Clubs Added by 1 user at least " -->
<div class="card col-md-12 col-sm-12">
  <div class="card-header">
    <h5>club added by at least <b>One</b> user
    </h5>
  </div>
  <div class=" card-body ">
    <apx-chart *ngIf="commonClubs" [series]="commonClubs.series" [chart]="commonClubs.chart"
      [labels]="commonClubs.labels" [colors]="commonClubs.colors" [legend]="commonClubs.legend"
      >
    </apx-chart>
  </div>

</div>

<!-- Number of repeated login by role -->
<div class="card col-md-12 col-sm-12 mr-3">
  <div class="card-header">
    <h5>Number of repeated Login by role last 7 days
    </h5>
  </div>
  <div class=" card-body ">
    <apx-chart *ngIf="repeatedLoginsByRole" [series]="repeatedLoginsByRole.series" [chart]="repeatedLoginsByRole.chart"
      [labels]="repeatedLoginsByRole.labels" [colors]="repeatedLoginsByRole.colors" [legend]="repeatedLoginsByRole.legend"
      >
    </apx-chart>
  </div>

</div>

  </div>
</div>
